"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Options_enum_1 = require("../../types/enums/Options.enum");
var BookingStatus_enum_1 = require("../../types/enums/BookingStatus.enum");
var gps = {
    '19': '115 Tudway Road-Branch (G83027)',
    '23': '161 Blackfen Road Blackfen (G83628)',
    '3': '2nd Floor The Greenwich Centre (G83021)',
    '45': '34 Plumstead Common Road-Branch (G83026)',
    '58': '7 day Healthcare-Branch (G83633)',
    '36': 'Abbeywood Surgery (G83031)',
    '21': 'Alderwood Road Surgery (G83036)',
    '35': 'All Saints Medical Centre (G83030)',
    '42': 'Bannockburn Surgery (G83654)',
    '39': 'Basildon Road Surgery (G83631)',
    '2': 'Blackheath Standard Surgery (G83013)',
    '25': 'Briset Corner Surgery (G83663)',
    '5': 'Burney Street Practice (G83065)',
    '12': 'Charlton Road Surgery-Branch (G83651)',
    '48': 'Clover Health Centre (Y03296)',
    '13': 'Coldharbour Hill PMS (G83003)',
    '30': 'Coldharbour Surgery (G83673)',
    '57': 'Conway Medical Centre (G83633)',
    '26': 'Eltham medical practice (G83680)',
    '15': 'Eltham Palace Surgery (G83015)',
    '20': 'Eltham Park Surgery (G83034)',
    '44': 'Escreet Grove Surgery (G83026)',
    '55': 'Ferryview Health Centre (G83067)',
    '52': 'Gallions Reach Health Centre (G83012)',
    '33': 'Garland Road HC-Branch (G83019)',
    '37': 'Glyndon Medical Centre (G83060)',
    '38': 'Glyndon PMS-Branch (G83060)',
    '29': 'Henley Cross Branch Surgery-Branch (G83017)',
    '28': 'Henley Cross Medical Centre (G83017)',
    '53': 'Heronsgate Medical Centre-Branch (G83012)',
    '1': 'Manor Brook Medical Centre (G83001)',
    '8': 'Millenium Village Health Centre (G83069)',
    '46': 'Mostafa PMS (G83647)',
    '22': 'New Eltham Medical Practice (G83628)',
    '50': 'Nightingale Surgery-Branch (G83039)',
    '10': 'Plumbridge Medical Centre (G83641)',
    '34': 'Plumstead Health Centre (G83019)',
    '18': 'Rochester Way Surgery-Branch (G83027)',
    '54': 'Royal Arsenal PMS (G83016)',
    '17': 'Sherard Road Medical Centre (G83027)',
    '7': 'Shooters Hill Medical Centre (Y02897)',
    '56': 'Shooters Hill surgery-Ferryview Branch (G83067)',
    '9': 'South St Medical Centre (G83058)',
    '49': 'St Marks Medical Centre (G83039)',
    '32': 'Tewson Road PMS (G83007)',
    '51': 'Thamesmead NHS Health Centre (Y02974)',
    '27': 'The Court Yard Surgery-Branch (G83680)',
    '4': 'The Fairfield Centre (G83044)',
    '31': 'The Hill -Branch (G83673)',
    '14': 'The Hill Surgery-Branch (G83003)',
    '24': 'The Mound (G83655)',
    '43': 'The Slade Surgery (G83668)',
    '59': 'The Trinity Medical Centre (Y02222)',
    '40': 'The Waverley Practice (G83635)',
    '6': 'Wallace centre-Branch (G83065)',
    '16': 'Westmount Road Surgery (G83022)',
    '47': 'Wickham Lane-Branch (G83647)',
    '41': 'Wickham Street-Branch (G83635)',
    '11': 'Woodland Walk Surgery (G83651)',
    '182': 'No registered GP',
    '984': "Don't know",
    '985': 'Out of borough',
    '983': 'Declined',
};
function keyMapper(trans, keys, path) {
    var obj = {};
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        obj[key] = trans(path + "." + key);
    }
    return obj;
}
function subEthnicityKeyMapper(trans, parent) {
    var _a, _b, _c, _d, _e, _f;
    var path = 'optiiva-utils::enum.sub-ethnicity';
    switch (parent) {
        case Options_enum_1.Ethnicity.WHITE:
            return _a = {},
                _a[Options_enum_1.SubEthnicity.BRITISH] = trans(path + "." + Options_enum_1.SubEthnicity.BRITISH),
                _a[Options_enum_1.SubEthnicity.IRISH] = trans(path + "." + Options_enum_1.SubEthnicity.IRISH),
                _a[Options_enum_1.SubEthnicity.TURKISH] = trans(path + "." + Options_enum_1.SubEthnicity.TURKISH),
                _a[Options_enum_1.SubEthnicity.NONE] = trans(path + "." + Options_enum_1.SubEthnicity.NONE),
                _a[Options_enum_1.SubEthnicity.OTHER] = trans(path + "." + Options_enum_1.SubEthnicity.OTHER),
                _a;
        case Options_enum_1.Ethnicity.BLACK_OR_BRITISH_BLACK:
            return _b = {},
                _b[Options_enum_1.SubEthnicity.CARIBBEAN] = trans(path + "." + Options_enum_1.SubEthnicity.CARIBBEAN),
                _b[Options_enum_1.SubEthnicity.AFRICAN] = trans(path + "." + Options_enum_1.SubEthnicity.AFRICAN),
                _b[Options_enum_1.SubEthnicity.OTHER] = trans(path + "." + Options_enum_1.SubEthnicity.OTHER),
                _b[Options_enum_1.SubEthnicity.NONE] = trans(path + "." + Options_enum_1.SubEthnicity.NONE),
                _b;
        case Options_enum_1.Ethnicity.ASIAN_OR_BRITISH_ASIAN:
            return _c = {},
                _c[Options_enum_1.SubEthnicity.INDIAN] = trans(path + "." + Options_enum_1.SubEthnicity.INDIAN),
                _c[Options_enum_1.SubEthnicity.PAKISTANI] = trans(path + "." + Options_enum_1.SubEthnicity.PAKISTANI),
                _c[Options_enum_1.SubEthnicity.BANGLADESHI] = trans(path + "." + Options_enum_1.SubEthnicity.BANGLADESHI),
                _c[Options_enum_1.SubEthnicity.OTHER] = trans(path + "." + Options_enum_1.SubEthnicity.OTHER),
                _c[Options_enum_1.SubEthnicity.NONE] = trans(path + "." + Options_enum_1.SubEthnicity.NONE),
                _c;
        case Options_enum_1.Ethnicity.CHINESE:
            return _d = {},
                _d[Options_enum_1.SubEthnicity.NONE] = trans(path + "." + Options_enum_1.SubEthnicity.NONE),
                _d;
        case Options_enum_1.Ethnicity.MIXED:
            return _e = {},
                _e[Options_enum_1.SubEthnicity.WHITE_AND_BLACK_CARIBBEAN] = trans(path + "." + Options_enum_1.SubEthnicity.WHITE_AND_BLACK_CARIBBEAN),
                _e[Options_enum_1.SubEthnicity.WHITE_AND_BLACK_AFRICAN] = trans(path + "." + Options_enum_1.SubEthnicity.WHITE_AND_BLACK_AFRICAN),
                _e[Options_enum_1.SubEthnicity.WHITE_AND_ASIAN] = trans(path + "." + Options_enum_1.SubEthnicity.WHITE_AND_ASIAN),
                _e[Options_enum_1.SubEthnicity.OTHER] = trans(path + "." + Options_enum_1.SubEthnicity.OTHER),
                _e[Options_enum_1.SubEthnicity.NONE] = trans(path + "." + Options_enum_1.SubEthnicity.NONE),
                _e;
        case Options_enum_1.Ethnicity.DECLINED:
        default:
            return _f = {},
                _f[Options_enum_1.SubEthnicity.NONE] = trans(path + "." + Options_enum_1.SubEthnicity.NONE),
                _f;
    }
}
function default_1(trans) {
    return {
        propertyTypes: function () {
            return keyMapper(trans, Object.values(Options_enum_1.PropertyType), 'optiiva-utils::enum.property-type');
        },
        propertyAges: function () {
            return keyMapper(trans, Object.values(Options_enum_1.PropertyAge), 'optiiva-utils::enum.property-age');
        },
        titles: function () { return keyMapper(trans, Object.values(Options_enum_1.Title), 'optiiva-utils::enum.title'); },
        genders: function () { return keyMapper(trans, Object.values(Options_enum_1.Gender), 'optiiva-utils::enum.gender'); },
        housingTenures: function () {
            return keyMapper(trans, Object.values(Options_enum_1.HousingTenure), 'optiiva-utils::enum.housing-tenure');
        },
        sexualOrientations: function () {
            return keyMapper(trans, Object.values(Options_enum_1.SexualOrientation), 'optiiva-utils::enum.sexual-orientation');
        },
        boolean: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanOption), 'laravel-utils::enum.boolean');
        },
        booleanOther: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanOther), 'laravel-utils::enum.boolean-other');
        },
        booleanMaybe: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanMaybe), 'laravel-utils::enum.boolean-maybe');
        },
        booleanOptional: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanOptional), 'laravel-utils::enum.boolean-optional');
        },
        BooleanOptionalUnsure: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanOptionalUnsure), 'laravel-utils::enum.boolean-optional-unsure');
        },
        booleanLoose: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanLoose), 'laravel-utils::enum.boolean-loose');
        },
        booleanPartial: function () {
            return keyMapper(trans, Object.values(Options_enum_1.BooleanPartial), 'laravel-utils::enum.boolean-partial');
        },
        languages: function () { return keyMapper(trans, Object.values(Options_enum_1.Language), 'optiiva-utils::enum.languages'); },
        disabilityCategories: function () {
            return keyMapper(trans, Object.values(Options_enum_1.DisabilityCategory), 'optiiva-utils::enum.disability-category');
        },
        religions: function () { return keyMapper(trans, Object.values(Options_enum_1.Religion), 'optiiva-utils::enum.religion'); },
        ethnicities: function () {
            return keyMapper(trans, Object.values(Options_enum_1.Ethnicity), 'optiiva-utils::enum.ethnicity');
        },
        subEthnicities: function (parent) { return subEthnicityKeyMapper(trans, parent); },
        gps: function () { return gps; },
        cancelledBookingStatuses: function () {
            var _a;
            return (_a = {},
                _a[BookingStatus_enum_1.BookingStatus.DNA] = trans("optiiva::enum.booking-status." + BookingStatus_enum_1.BookingStatus.DNA),
                _a[BookingStatus_enum_1.BookingStatus.CANCELLED] = trans("optiiva::enum.booking-status." + BookingStatus_enum_1.BookingStatus.CANCELLED),
                _a[BookingStatus_enum_1.BookingStatus.CANCELLED_REBOOK] = trans("optiiva::enum.booking-status." + BookingStatus_enum_1.BookingStatus.CANCELLED_REBOOK),
                _a[BookingStatus_enum_1.BookingStatus.CANCELLED_NOT_ATTEND] = trans("optiiva::enum.booking-status." + BookingStatus_enum_1.BookingStatus.CANCELLED_NOT_ATTEND),
                _a[BookingStatus_enum_1.BookingStatus.CANCELLED_NO_INTEREST] = trans("optiiva::enum.booking-status." + BookingStatus_enum_1.BookingStatus.CANCELLED_NO_INTEREST),
                _a);
        },
    };
}
exports.default = default_1;
//# sourceMappingURL=Options.js.map